export default {
    name: 'IMedia'
};
